'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle(".lifepal-loader {\n  border-radius: 50%;\n  -webkit-animation: spin 1s linear infinite;\n  /* Safari */\n  animation: spin 1s linear infinite;\n  /* Safari */\n}\n.lifepal-loader__sm {\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #3498db;\n  width: 20px;\n  height: 20px;\n}\n.lifepal-loader__md {\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid #3498db;\n  width: 30px;\n  height: 30px;\n}\n.lifepal-loader__lg {\n  border: 10px solid #f3f3f3;\n  border-top: 10px solid #3498db;\n  width: 60px;\n  height: 60px;\n}\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}");
//# sourceMappingURL=LifepalLoader.scss.js.map
